import { PARTNER_FORM, EXPORT_FILE_TYPE } from './form-partner-types';
import { dropdown } from '../../dropdown';
import { checkForSelectValue } from '../form-helpers';
import { showToast } from '../../toasts';

import PostPartnerNew from '../../../routes/post-new-partner'

/**
 * Post new partner to AWS
 */
export const postNewPartner = () => {
  if (!PARTNER_FORM.partnerForm) return;

  const { partnerForm, partnerName, partnerAccountNumber, partnerFileType, partnerSubmit }  = PARTNER_FORM;

  dropdown(EXPORT_FILE_TYPE, 'file', 'File Type', false, true, true);

  const validateForm = () => {
    partnerForm.classList.add('was-validated');

    checkForSelectValue(partnerFileType, 'File Type', 'file');

    return partnerForm.checkValidity() &&
        partnerFileType.getAttribute('data-value') != null;
  }

  const handlePostPartner = async (awsData: any) => {
    const { body } = await PostPartnerNew(awsData);

    if ( body ) {
      showToast('aafp_toast', `${partnerName.value} has been added`);
      setTimeout(() => {
        location.href = '/edit-partner';
      }, 1500);
    }
  }  

  partnerForm.addEventListener('submit', async (event) => {
    if ( validateForm() ) {
      partnerForm.classList.remove('form-control:valid');
      partnerSubmit.classList.add('aafp_button-loading');

      const partnerPathName = partnerName.value.replace(/[^A-Za-z]/g, '');

      const awsData = {
        partnerName: partnerName.value,
        accountNumber: partnerAccountNumber.value,
        exportTo: partnerPathName,
        exportFileType: String(partnerFileType.getAttribute('data-value'))
      };

      handlePostPartner(awsData);
    }
  });
}